<script>
  import ModuleBlock from './Modules/ModuleBlock.svelte';
  import TextElements from './Modules/TextElements/TextElements.svelte';

  const advancedComponents = [
    {
      component: TextElements,
      open: true,
      expandable: false,
      nobg: true
    }
  ];
</script>

<div class="grid w-full gap-3">
  {#each advancedComponents as component}
    <ModuleBlock {...component} />
  {/each}
</div>
